import { React } from 'react';


const MagnifyOff = ({color}) => (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_53_107)">
<path d="M56 48.2074L46.3879 38.5953C49.023 34.8224 50.5801 30.2409 50.5801 25.2901C50.5801 12.4273 40.1495 2 27.2901 2C14.4306 2 4 12.4273 4 25.2901C4 38.1528 14.4273 48.5801 27.2901 48.5801C32.2409 48.5801 36.8256 47.023 40.5986 44.3879L50.2108 54L56 48.2074ZM27.2867 41.9291C18.1005 41.9291 10.651 34.4829 10.651 25.2934C10.651 16.1038 18.1005 8.65765 27.2867 8.65765C36.4763 8.65765 43.9224 16.1038 43.9224 25.2934C43.9258 34.4829 36.4796 41.9291 27.2867 41.9291ZM17.3053 28.6172H37.2682V21.9629H17.3053V28.6172Z" fill={color}/>
</g>
<defs>
<filter id="filter0_d_53_107" x="0" y="0" width="60" height="60" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood floodOpacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="2"/>
<feGaussianBlur stdDeviation="2"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_53_107"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_53_107" result="shape"/>
</filter>
</defs>
</svg>

)

export default MagnifyOff